<template>
  <div>
    <h5>{{ trans('gift_cards') }}</h5>
    <p>
      {{ trans('access_gift_cards_instructions') }}
      <b-button v-if="!pos" variant="link" size="sm" class="text-branded" :href="`/org/${organization.id}/client`" target="_blank" :disabled="busy">
          {{ trans('my_account') }}
          <i class="fa fa-fw fa-external-link-alt"></i>
      </b-button>
      <b-button v-if="showAdminOptions" variant="outline-danger" size="sm" class="ml-2 py-0" @click="onAdminClickChooseGiftCard" :disabled="busy">
        {{ trans('choose_a_gift_card') }}
      </b-button>
    </p>
    <div v-if="appliedGiftCards.length > 0">
      <strong class="d-block">{{ trans('applied_gift_cards') }}</strong>
      <ul>
        <li v-for="gift_card in appliedGiftCards" :key="'gc'+gift_card.gift_card_no">
          {{ trans('gift_card') }}
          <small class="text-muted">{{ printGiftCardNo(gift_card.organization_id, gift_card.gift_card_no) }}</small>
          <strong><dollar :value="gift_card.amount"></dollar></strong>
          <b-button variant="link" size="sm" class="py-0 text-danger" @click="onRemoveGiftCard(gift_card)" :disabled="busy">
            <i class="fa fa-fw fa-times"></i>
            <small>{{ trans('remove') }}</small>
          </b-button>
        </li>
      </ul>
    </div>
    <p class="mb-1">
      {{ trans('gift_card_payment_instructions') }}
    </p>
    <b-form-group>
      <b-form-input
        v-model="gift_card_code"
        placeholder="XXXXXXX-XXXXXXX"
        :formatter="giftCardCodeFormatter"
        autocomplete="off"
        :disabled="busy"
      />
    </b-form-group>
    <admin-choose-gift-card-modal
      :id="adminChooseGiftCardModalId"
      :organization="organization"
      :email="clientEmail"
      not-empty
      @chosen="onAdminChoseGiftCard"
    ></admin-choose-gift-card-modal>
  </div>
</template>

<script>
  import AdminChooseGiftCardModal from './../gift-card/AdminChooseGiftCardModal'
  import Dollar from './../billing/Dollar'

  export default {
    props: {
      source: {
        type: String,
        default: 'payment', // payment or admin-options
      },
      organization: Object,
      invoice: Object,
      pos: Object, // null when in microsite
      baseUrl: String,
    },
    components: {
      AdminChooseGiftCardModal,
      Dollar,
    },
    data() {
      return {
        trans: trans,
        printGiftCardNo: _.printGiftCardNo,
        busy: false,
        error: null,
        gift_card_code: null,
      }
    },
    computed: {
      showAdminOptions() {
        return this.organization.auth_user &&
          this.organization.auth_user.microsite_permissions.has_admin_payments &&
          !!this.invoice.admin
      },
      appliedGiftCards() {
        return _.reduce(this.invoice.payments || [], (gift_cards, payment) => {
          if (payment.type == 'gift_card') gift_cards.push({
            organization_id: payment.organization_id,
            gift_card_no: payment.gift_card_no,
            amount: payment.amount
          })
          return gift_cards
        }, [])
      },
      clientEmail() {
        if (!this.invoice || this.invoice.is_no_client || !this.invoice.recipient) return null
        return this.invoice.recipient.email || null
      },
      adminChooseGiftCardModalId() {
        return `${this.source}-choose-gift-card-modal`
      },
    },
    watch: {
      busy() {
        this.$emit('busy', this.busy)
      },
      error() {
        this.$emit('error', this.error)
      },
    },
    methods: {
      giftCardCodeFormatter(value) {
        let x = value.replace(/[^A-Za-z0-9]/g, '').match(/([A-Za-z0-9]{0,7})([A-Za-z0-9]{0,7})/);
        if (!!x && x[0].length <= 14) {
            value = !x[2] ? x[1] : '' + x[1] + '-' + x[2];
        }
        return value
      },
      onAdminClickChooseGiftCard() {
        this.$bvModal.show(this.adminChooseGiftCardModalId)
      },
      onAdminChoseGiftCard(gift_card) {
        this.gift_card_code = gift_card.code
        this.$bvModal.hide(this.adminChooseGiftCardModalId)
        this.$nextTick(this.onApplyGiftCard)
      },
      buildUrl(uri) {
        let url = this.baseUrl || `/org/${this.organization.id}/cart`
        return url += uri
      },
      onApplyGiftCard() {
        this.busy = true
        this.error = null
        let url = this.buildUrl('/apply_gift_card')
        axios.post(url, {code: this.gift_card_code})
        .then(response => {
          this.busy = false
          this.$emit('invoice', response.data)
          this.gift_card_code = null
          if (!!response.data.finalized_at) {
            this.$nextTick(() => {
              this.$emit('next')
            })
          }
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onRemoveGiftCard(gift_card) {
        this.busy = true
        this.error = null
        let url = this.buildUrl(`/remove_gift_card/${gift_card.gift_card_no}`)
        axios.delete(url)
        .then(response => {
          this.busy = false
          this.$emit('invoice', response.data)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.posGiftCards = this
    },
  }
</script>